package com.cs.ejobin.navigation

/**
 * Mapping simple Screen <-> URL (Web only).
 * iOS/Android ignorent totalement ces paths.
 */
object WebRoutes {

    fun toPath(screen: Screen): String = when (screen) {
        Screen.Login -> "/login"
        Screen.Signup -> "/signup"
        Screen.ForgotPasswordEmail -> "/forgot-password"
        Screen.ForgotPasswordOtp -> "/forgot-password/otp"
        Screen.ResetPassword -> "/reset-password"
        Screen.Home -> "/home"
        Screen.Profile -> "/profile"
        is Screen.ExtraDetail -> "/extra/${encode(screen.extraId)}"

        // ✅ Paiement désactivé : on ne génère plus d'URL /paywall
        is Screen.Paywall -> "/home"

        // ✅ Paiement désactivé : on ne garde pas ces routes (optionnel)
        Screen.CheckoutSuccess -> "/home"
        Screen.CheckoutCancel -> "/home"
    }

    fun fromPath(pathname: String, query: Map<String, String>): Screen {
        val path = pathname.ifBlank { "/" }

        return when {
            path == "/" -> Screen.Login
            path == "/home" -> Screen.Home
            path == "/login" -> Screen.Login
            path == "/signup" -> Screen.Signup
            path == "/forgot-password" -> Screen.ForgotPasswordEmail
            path == "/forgot-password/otp" -> Screen.ForgotPasswordOtp
            path == "/reset-password" -> Screen.ResetPassword
            path == "/profile" -> Screen.Profile
            path.startsWith("/extra/") -> {
                val id = decode(path.removePrefix("/extra/"))
                Screen.ExtraDetail(id)
            }

            // ✅ Paiement désactivé : si quelqu'un tape /paywall, on le redirige Home
            path == "/paywall" -> Screen.Home

            // ✅ Paiement désactivé : idem checkout
            path == "/checkout/success" -> Screen.Home
            path == "/checkout/cancel" -> Screen.Home

            else -> Screen.Login
        }
    }

    private fun encode(s: String): String =
        s.replace("%", "%25").replace("/", "%2F").replace(" ", "%20")

    private fun decode(s: String): String =
        s.replace("%20", " ").replace("%2F", "/").replace("%25", "%")
}